import AttachmentsList from "./AttachmentsList/AttachmentsList"
import { AttachmentsViewWrapper } from "./ui"
import { attachmentsAreEmpty, previewAttachmentData } from "./utils"

export const AttachmentsView = ({ data, id, preview }) => {
  const attachments = preview ? previewAttachmentData : data.files

  return (
    <AttachmentsViewWrapper empty={!preview && attachmentsAreEmpty(data.files)}>
      <AttachmentsList attachments={attachments} blockID={id} mode="view" />
    </AttachmentsViewWrapper>
  )
}

export default AttachmentsView
